/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyRateStatRequest
 */
export interface DailyRateStatRequest {
    /**
     * 
     * @type {string}
     * @memberof DailyRateStatRequest
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof DailyRateStatRequest
     */
    experienceLevel: string;
}

/**
 * Check if a given object implements the DailyRateStatRequest interface.
 */
export function instanceOfDailyRateStatRequest(value: object): value is DailyRateStatRequest {
    if (!('experienceLevel' in value) || value['experienceLevel'] === undefined) return false;
    return true;
}

export function DailyRateStatRequestFromJSON(json: any): DailyRateStatRequest {
    return DailyRateStatRequestFromJSONTyped(json, false);
}

export function DailyRateStatRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyRateStatRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'experienceLevel': json['experienceLevel'],
    };
}

export function DailyRateStatRequestToJSON(value?: DailyRateStatRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'category': value['category'],
        'experienceLevel': value['experienceLevel'],
    };
}

